import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Input, List, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { updateCoordinate, updatePlaceName } from '../../redux/reducer/SoilCreatProfiles';
import GoogleMapReact from 'google-map-react';
import IF from '../IF';
import {
    SearchSvgComponent,
    SoilNewReactIcon,
    SoilProfileMapClose,
    SoilProfileMapCurrentLocationIcon,
    SoilProfileZoomIn,
    SoilProfileZoomOut,
    SoilSearchAddPolyLinePoint,
    SoilSearchCircleIcon,
    SoilSearchClearPolyIcon,
    SoilSearchiCircleSelectedIcon,
    SoilSearchProfileCount,
    SoilSearchRectIcon,
    SoilSearchRectSelectedIcon
} from '../../resource/IconComponentSets';
import SoilProfileMarker from './Component/SoilProfileMarker';
import { SoilProfileMarker as NormalSoilProfileMarker } from '../../resource/IconComponentSets';
import './index.less';
import {
    soilProfileGetPlaceNameByLatLong,
    soilProfileGetPlaceNameByString
} from '../../util/Request';
import {
    GetPropertyListResponseModel,
    ISoilProfilePlaceGeoNames,
    ISoilSearchProfilePointResModel
} from '../../util/Request/requestType';
import useSupercluster from 'use-supercluster';
import { updateWarningMessage } from '../../redux/reducer/common';
import { RootState } from '@reduxjs/toolkit';
import { updateFourthDrawFlag, updateFourthTabValues } from '@/redux/reducer/soilSerach';


interface ICoordinate {
    lat: number
    lng: number
}

interface IProps {
    clearMapTag?: number
    actionPanelCloseCallBack?: () => void
    includePanel?: boolean
    defaultCoordinate?: ISoilSearchProfilePointResModel
    type?: 'FIND' | 'SHOW' | 'QUERY'
    coordinates?: ISoilSearchProfilePointResModel[]
    defaultZoom?: number
    propertySet?: GetPropertyListResponseModel[]
    showPolyMenu?: boolean,
    // polyPathCallback?: (pathPoint: ICoordinate[]) => void
}

const GoogleMapReactComponent = (props: IProps) => {
    const {
        actionPanelCloseCallBack,
        includePanel = false,
        type = 'SHOW',
        coordinates,
        defaultCoordinate,
        defaultZoom,
        propertySet,
        showPolyMenu,
        // polyPathCallback,
        clearMapTag,
    } = props;

    const mapRef = useRef(null);
    const mapsRef = useRef(null);
    const polyLineSetRef = useRef([]);
    const polygonRef = useRef(null);
    const polygonCircleRef = useRef(null);

    const defaultCenter = {
        lat: 10.99835602,
        lng: 77.01502627
    };

    const dispatch = useDispatch();

    // SECTION: state defined area
    const [geoDataSource, setGeoDataSource] = useState<ISoilProfilePlaceGeoNames[]>([]);
    const [inputLatLngValue, setInputLatLngValue] = useState<string>('');
    const [selectedCoordinate, setSelectedCoordinate] = useState<ICoordinate | undefined>();
    const [searchButtonEnable, setSearchButtonEnable] = useState(false);
    const [loading, setLoading] = useState(false);
    const [geonameId, setGeonameId] = useState<number>();
    const [bounds, setBounds] = useState(null);
    const [zoom, setZoom] = useState(10);
    const [points, setPoints] = useState([]);
    const [polyLinePointsComponent, setPolyLinePointsComponent] = useState<any>([]);
    // const [drawReactModel, setDrawReactModel] = useState(false);
    // const [drawCircleMode, setDrawCircleMode] = useState(false);
    const [clickPoint, setClickPoint] = useState<any>();
    const [mapLoadFinish, setMapLoadFinish] = useState(false);
    // if enter the polyline model
    // const [polylinePoint, setPolylinePoint] = useState<ICoordinate[]>([]);

    const [polygonExist, setPolygonExist] = useState(false);
    const {
        coordinate,
        clearTag
    } = useSelector((state: RootState) => state.soilprofileCreateData);

    const {
        polyPoint,
        drawCircleMode,
        drawReactModel,
        fromQueryHistory,
        center,
        radius
    } = useSelector((state: RootState) => state.soilSearchPageData);

    // SECTION: -----------------------Function area------------------------------------
    const handleSearchButtonClick = async () => {
        if (!searchButtonEnable) {
            return;
        }
        if (!inputLatLngValue || inputLatLngValue.length === 0) {
            return;
        }
        try {
            setLoading(true);
            const splitResult = inputLatLngValue.split(',');
            let result;
            if(splitResult.length === 2) {
                result = await soilProfileGetPlaceNameByLatLong(parseInt(splitResult[1]), parseInt(splitResult[0]));
            } else {
                result = await soilProfileGetPlaceNameByString(inputLatLngValue);
            }
            setGeoDataSource(result.geoNames);
            setLoading(false);
        } catch(err) {
            console.log('err', err);
            dispatch(updateWarningMessage('none result match current location!!'));
            setLoading(false);
        }
    };

    const handleInputValueChange = (e) => {
        setInputLatLngValue(e.target.value);
        if (e.target.value.length === 0) {
            return setSearchButtonEnable(false);
        }
        setSearchButtonEnable(true);
        const latLonValidate = validateLatAndLon(e.target.value);
        if (latLonValidate) {
            dispatch(updateCoordinate(e.target.value));
        }
    };

    const handleAddressClick = (geoValue: ISoilProfilePlaceGeoNames) => {
        // dispatch(updateCoordinate(`${geoValue.lat},${geoValue.lng}`));
        // dispatch(updatePlaceName(geoValue));
        const coordinate = {lat: geoValue.lat, lng: geoValue.lng};
        // setSelectedCoordinate(coordinate);
        // setGeonameId(geoValue.geonameId);
        // click search result map would set center to target point
        mapRef.current.setCenter(coordinate);
    };

    const handleShowCurrentLocation = () => {
        navigator.geolocation.getCurrentPosition(
            (position: GeolocationPosition) => {
                const pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                setSelectedCoordinate(pos);
                if (mapRef && mapRef.current) {
                    mapRef.current.setCenter(pos);
                }
            },
            () => {
                console.log('test get current location error');
            }
        );
    };


    const handleCloseMap = () => {
        actionPanelCloseCallBack && actionPanelCloseCallBack();
        setSearchButtonEnable(false);
        setGeoDataSource([]);
        setInputLatLngValue('');
        autoCenterCurrentLocation();
        setSelectedCoordinate(undefined);
        setGeonameId(undefined);
    };

    const autoCenterCurrentLocation = () => {
        navigator.geolocation.getCurrentPosition(
            (position: GeolocationPosition) => {
                const pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
                setSelectedCoordinate(pos);
                setZoom(20);
            },
            () => {
                console.log('test get current location error');
            });
    };

    const handleAnnotationClick = (item: ISoilProfilePlaceGeoNames) => {
        mapRef && mapRef.current.setCenter({ lat: item.lat, lng: item.lng });
    };

    const handleGoogleApiLoaded = useCallback(({ map, maps }) => {
        mapRef.current = map;
        mapsRef.current = maps;
        setMapLoadFinish(true);
    }, []);

    const handleDrawPolygon = useCallback((event?) => {
        if (polyPoint.length > 2 && !polygonExist) {
            mapClick(event);

            const geodesicPolygon = new mapsRef.current.Polygon({
                paths: polyPoint,
                strokeColor: 'white',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: 'white',
                fillOpacity: 0.35
            });
            geodesicPolygon.setMap(mapRef.current);
            setPolygonExist(true);
            polygonRef.current = geodesicPolygon;
        }
    }, [polyPoint]);

    const mapClick = async (event, radius?: number) => {
        if (polygonExist) {
            clearAll();
        }

        if (drawCircleMode) {
            // if draw the circle should clear circle add before
            polygonCircleRef.current?.setMap(null);
            const localZoom = 23 - zoom;
            const radius = localZoom * Math.pow(localZoom < 7 ? 10 : 100, (Math.round(localZoom / 10)));
            const lat = event.lat;
            const lng = event.lng;
            const polygonCircle = new mapsRef.current.Circle({
                strokeColor: 'orange',
                strokeOpacity: 1,
                strokeWeight: 2,
                fillColor: '#FFFFFF',
                fillOpacity: 0.1,
                map: mapRef.current,
                center: {lat, lng},
                radius,
                editable: true
            });
            const bottomLat = event.lat - radius / 110000;
            const topLat = lat + radius / 110000;
            const leftLng = lng + radius / 110000;
            const rightLng = lng - radius / 110000;
            const top = {lat: topLat, lng};
            const left = { lat, lng: leftLng};
            const bottom = {lat: bottomLat, lng};
            const right = { lat, lng: rightLng };
            const pathPoint = [top, left, bottom, right];
            dispatch(updateFourthTabValues({
                circlePoint: pathPoint,
                polyPoint: pathPoint,
                center,
                radius
            }));
            mapsRef.current.event.addListener(polygonCircle, 'radius_changed', function() {
                console.log(polygonCircle.getRadius());
                const radius = polygonCircle.getRadius();
                const center = polygonCircle.getCenter();
                const lat = center.lat();
                const lng = center.lng();
                // 10000 lat translate
                const bottomLat = lat - radius / 110000;
                const topLat = lat + radius / 110000;
                const leftLng = lng + radius / 110000;
                const rightLng = lng - radius / 110000;
                const top = {lat: topLat, lng};
                const left = { lat, lng: leftLng};
                const bottom = {lat: bottomLat, lng};
                const right = { lat, lng: rightLng };
                const pathPoint = [top, left, bottom, right];

                // polyPathCallback(pathPoint);
                dispatch(updateFourthTabValues({
                    circlePoint: pathPoint,
                    polyPoint: pathPoint,
                    center,
                    radius
                }));
            });

            mapsRef.current.event.addListener(polygonCircle, 'center_changed', () => {
                console.log(polygonCircle.getRadius());
                const radius = polygonCircle.getRadius();
                const center = polygonCircle.getCenter();
                const lat = center.lat();
                const lng = center.lng();
                // 10000 lat translate
                const bottomLat = lat - radius / 110000;
                const topLat = lat + radius / 110000;
                const leftLng = lng + radius / 100000;
                const rightLng = lng - radius / 100000;
                const top = {lat: topLat, lng};
                const left = { lat, lng: leftLng};
                const bottom = {lat: bottomLat, lng};
                const right = { lat, lng: rightLng };
                const pathPoint = [top, left, bottom, right];

                // polyPathCallback(pathPoint);
                dispatch(updateFourthTabValues({
                    circlePoint: pathPoint,
                    polyPoint: pathPoint,
                    center: { lat, lng },
                    radius
                }));
            });
            return polygonCircleRef.current = polygonCircle;
        }

        if (drawReactModel) {
            let newPolyPoint;
            if (polygonExist) {
                // add latest point to the line set
                newPolyPoint = [];
                setPolygonExist(false);
                polyLineSetRef.current.forEach(polyLine => {
                    polyLine.setMap(null);
                });
                polygonRef.current.setMap(null);
                polyLineSetRef.current = [];
            } else {
                // newPolyPoint = [...polylinePoint];
                newPolyPoint = [...polyPoint];
            }
            const currentPoint = { lat: event.lat, lng: event.lng };
            newPolyPoint.push(currentPoint);
            // setPolylinePoint(newPolyPoint);
            dispatch(updateFourthTabValues({polyPoint: newPolyPoint}));
            const geodesicPolyline = new mapsRef.current.Polyline({
                path: newPolyPoint,
                geodesic: false,
                strokeColor: 'orange',
                strokeOpacity: 0.7,
                strokeWeight: 2
            });

            geodesicPolyline.setMap(mapRef.current);
            if (polyLineSetRef.current && polyLineSetRef.current.length == 0) {
                polyLineSetRef.current = [geodesicPolyline];
            } else {
                polyLineSetRef.current.push(geodesicPolyline);
            }
        }
        if (type === 'FIND') {
            const latLonValue = `${parseFloat(event.lng).toFixed(7)},${parseFloat(event.lat).toFixed(7)}`;
            setInputLatLngValue(latLonValue);
            dispatch(updateCoordinate(latLonValue));
        }
    };

    useEffect(() => {
        console.log('polyPoint:====', polyPoint);
    }, [polyPoint]);
    useEffect(() => {
        if (fromQueryHistory && mapLoadFinish) {
            if (drawReactModel && polyLineSetRef.current) {
                let newPolyPoint;
                if (polygonExist) {
                // add latest point to the line set
                    newPolyPoint = [];
                    polyLineSetRef.current.forEach(polyLine => {
                        polyLine.setMap(null);
                    });
                    polygonRef.current.setMap(null);
                    polyLineSetRef.current = [];
                }
                const firstPoint = polyPoint[0];
                newPolyPoint = [...polyPoint];
                newPolyPoint.push(firstPoint);

                const geodesicPolyline = new mapsRef.current.Polyline({
                    path: newPolyPoint,
                    geodesic: false,
                    strokeColor: 'orange',
                    strokeOpacity: 0.7,
                    strokeWeight: 2,
                });
                const geodesicPolygon = new mapsRef.current.Polygon({
                    paths: polyPoint,
                    strokeColor: 'white',
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: 'white',
                    fillOpacity: 0.35
                });
                if (polyLineSetRef.current && polyLineSetRef.current.length == 0) {
                    polyLineSetRef.current = [geodesicPolyline];
                } else {
                    polyLineSetRef.current.push(geodesicPolyline);
                }
                polygonRef.current = geodesicPolygon;
                geodesicPolyline.setMap(mapRef.current);
                geodesicPolygon.setMap(mapRef.current);
                dispatch(updateFourthTabValues({ fromQueryHistory: false }));

                // handleDrawPolygon({ lat: firstPoint.lat, lng: firstPoint.lng });
            }
            if (drawCircleMode) {
                polygonCircleRef.current?.setMap(null);
                const polygonCircle = new mapsRef.current.Circle({
                    strokeColor: 'orange',
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    fillColor: '#FFFFFF',
                    fillOpacity: 0.1,
                    map: mapRef.current,
                    center: {lat: center.lat, lng: center.lng},
                    radius: radius || 10000,
                    editable: true
                });
                mapsRef.current.event.addListener(polygonCircle, 'radius_changed', function() {
                    console.log(polygonCircle.getRadius());
                    const radius = polygonCircle.getRadius();
                    const center = polygonCircle.getCenter();
                    const lat = center.lat;
                    const lng = center.lng;
                    // 10000 lat translate
                    const bottomLat = lat - radius / 110000;
                    const topLat = lat + radius / 110000;
                    const leftLng = lng + radius / 100000;
                    const rightLng = lng - radius / 100000;
                    const top = {lat: topLat, lng};
                    const left = { lat, lng: leftLng};
                    const bottom = {lat: bottomLat, lng};
                    const right = { lat, lng: rightLng };
                    const pathPoint = [top, left, bottom, right];

                    // polyPathCallback(pathPoint);
                    dispatch(updateFourthTabValues({
                        circlePoint: pathPoint,
                        polyPoint: pathPoint,
                        center,
                        radius,
                        fromQueryHistory: false
                    }));
                });
            }
            setPolygonExist(true);
        }
    }, [fromQueryHistory, mapLoadFinish]);

    const clearButtonClick = () => {
        // remove all poly
        // setPolylinePoint([]);
        dispatch(updateFourthTabValues({ polyPoint: [] }));
        // reset draw flag
        dispatch(updateFourthDrawFlag({
            drawCircleMode: false,
            drawReactModel: false
        }));
        // clear all line
        polyLineSetRef.current?.forEach(polyLineRef => {
            polyLineRef.setMap(null);
        });
        // clear the react
        polygonRef.current?.setMap(null);
        setPolygonExist(false);
        polygonCircleRef.current?.setMap(null);
    };

    const clearAll = () => {
        // clear all line here
        // setPolylinePoint([]);
        dispatch(updateFourthTabValues({ polyPoint: [] }));
        // clear all line
        polyLineSetRef.current?.forEach(polyLineRef => {
            polyLineRef.setMap(null);
        });
        // clear the react
        polygonRef.current?.setMap(null);
        setPolygonExist(false);

        polygonCircleRef.current?.setMap(null);
    };


    // SECTION: -----------------------useEffect area------------------------------------
    // useEffect(() => {
    //     if (type !== 'FIND') {
    //         return;
    //     }
    //     if (geoDataSource && geoDataSource.length > 0) {
    //         const marks = geoDataSource.map((item) => (
    //             <SoilProfileMarker
    //                 key={item.geonameId}
    //                 lat={item.lat}
    //                 lng={item.lng}
    //                 onClick={() => handleAnnotationClick(item)}
    //                 className='soil-map-maker'
    //             >
    //             </SoilProfileMarker>
    //         ));
    //         setSearchPoints(marks);
    //     }
    // }, [geoDataSource]);

    useEffect(() => {
        if (!showPolyMenu && !fromQueryHistory) {
            clearButtonClick();

            // dispatch(updateFourthTabValues({
            //     drawCircleMode: false,
            //     drawReactModel: false
            // }));
        }
    }, [showPolyMenu]);

    useEffect(() => {
        if (clearTag > 0) {
            handleCloseMap();
        }
    }, [clearTag]);

    useEffect(() => {
        if (!coordinate || coordinate && coordinate.length == 0) {
            setInputLatLngValue('');
            setClickPoint(null);
        }
        if (type === 'FIND' && coordinate && coordinate.split(',').length === 2) {
            const coordinateArr = coordinate.split(',');
            const latStr = coordinateArr[1];
            const lngStr = coordinateArr[0];
            if (latStr.length === 0 || lngStr.length === 0) {
                return;
            }
            const lat = parseFloat(latStr);
            const lng = parseFloat(lngStr);
            const currentPointMark = <NormalSoilProfileMarker
                key={'specify-key'}
                lat={lat}
                lng={lng}
                onClick={() => console.log('test1!!!!!')}
                className='soil-map-maker'
            >
            </NormalSoilProfileMarker>;
            setClickPoint(currentPointMark);
            setInputLatLngValue(coordinate);
        }
    }, [coordinate]);

    useEffect(() => {
        const polyPointSets = polyPoint?.map(((item, index) =>{
            if (index === 0) {
                return (
                    <SoilSearchAddPolyLinePoint
                        key={'first'}
                        style={{
                            position: 'relative',
                            top: '-14px',
                            right: '14px',
                            display: 'flex',
                            width: '30px',
                            height: '30px',
                            justifyContent: 'center',
                            alignItems: 'center',
                            cursor: 'pointer',
                            zIndex: '999',
                        }}
                        lat={item.lat}
                        lng={item.lng}
                        onClick={() => handleDrawPolygon(item)}
                    />
                );
            } else {
                return (
                    <SoilSearchAddPolyLinePoint
                        key={`${item.lat}-${item.lng}`}
                        style={{
                            position: 'relative',
                            top: '-8px',
                            right: '8px'
                        }}
                        lat={item.lat}
                        lng={item.lng}
                    />
                );
            }
        } ));
        setPolyLinePointsComponent(polyPointSets);
    }, [polyPoint]);

    useEffect(() => {
        if (coordinates && coordinates.length > 0) {
            const geoJsonPoints = coordinates.map((item, index) => {
                return {
                    type: 'Feature',
                    properties: {
                        cluster: false,
                        crimeId: `${item.countryCode}-${item.lat}-${index}`,
                        category: 'anti-social-behaviour'
                    },
                    profileId: item.profileID,
                    profileCode: item.profileCode,
                    geometry: {
                        type: 'Point',
                        coordinates: [
                            item.lng,
                            item.lat
                        ]
                    }
                };
            });
            setPoints(geoJsonPoints);
            if (coordinates.length > 0) {
                mapRef && mapRef.current && mapRef.current.setCenter(coordinates[0]);
            }
        }

        if (coordinates && coordinates.length === 0) {
            setPoints([]);
        }
    }, [coordinates]);

    const { clusters } = useSupercluster({
        points,
        bounds,
        zoom,
        options: { radius: 75, maxZoom: 15 }
    });

    useEffect(() => {
        if (type !== 'SHOW') {
            return;
        }
        if (mapRef.current != null) {
            mapRef.current.setCenter(defaultCoordinate);
        }
    }, [defaultCoordinate, mapRef]);

    useEffect(() => {
        clearAll();
    }, [clearMapTag]);

    useEffect(() => {
        if (drawCircleMode) {
            // clear all line here
            // setPolylinePoint([]);
            dispatch(updateFourthTabValues({ polyPoint: [] }));
            // clear all line
            polyLineSetRef.current?.forEach(polyLineRef => {
                polyLineRef.setMap(null);
            });
            // clear the react
            polygonRef.current?.setMap(null);
            setPolygonExist(false);
        }
        if (drawReactModel) {
            polygonCircleRef.current?.setMap(null);
        }
    }, [drawCircleMode, drawReactModel]);

    useEffect(() => {
        if (type === 'SHOW') {
            return;
        }
        autoCenterCurrentLocation();
    }, []);

    useEffect(() => {
        setSearchButtonEnable(true);
        if (inputLatLngValue && inputLatLngValue.length > 0) {
            const coordinateArr = inputLatLngValue.split(',');
            const latStr = coordinateArr[1];
            const lngStr = coordinateArr[0];
            if (!latStr || !lngStr || (latStr && latStr.length === 0) || (lngStr && lngStr.length === 0)) {
                return;
            }
            const lat = parseFloat(latStr);
            const lng = parseFloat(lngStr);
            const latLonValidate = validateLatAndLon(inputLatLngValue);
            if (latLonValidate) {
                const currentPointMark = <NormalSoilProfileMarker
                    key={'specify-key'}
                    lat={lat}
                    lng={lng}
                    onClick={() => console.log('test1!!!!!')}
                    className='soil-map-maker'
                >
                </NormalSoilProfileMarker>;
                setClickPoint(currentPointMark);
                if (mapRef && mapRef.current !== null) {
                    mapRef.current.setCenter({lat, lng});
                }
            }
        }
    }, [inputLatLngValue]);

    const validateLatAndLon = (inputLatLngValue: string) => {
        const coordinateArr = inputLatLngValue.split(',');
        const latStr = coordinateArr[1];
        const lngStr = coordinateArr[0];
        if (!latStr || !lngStr || (latStr && latStr.length === 0) || (lngStr && lngStr.length === 0)) {
            return false;
        }
        const lonReg = /^[-+]?(0(\.\d{1,10})?|([1-9](\d)?)(\.\d{1,10})?|1[0-7]\d{1}(\.\d{1,10})?|180\.0{1,10})$/;
        const latReg = /^[-+]?((0|([1-8]\d?))(\.\d{1,10})?|90(\.0{1,10})?)$/;
        const lonValidate = lonReg.test(coordinateArr[0].replace(/\s+/g, ''));
        const latValidate = latReg.test(coordinateArr[1].replace(/\s+/g, ''));
        return lonValidate && latValidate;
    };

    return (
        <Spin spinning={loading} style={{height: '100%'}}>
            <div className={`${type === 'FIND' && 'map-view-in-modal-style'}`}>
                <IF show={includePanel}>
                    <div className='map-menu-action-panel'>
                        <div className='map-menu-first-div'>
                            <span>
                              Map
                            </span>
                            <button
                                className='map-close-button'
                                onClick={() => actionPanelCloseCallBack()}
                            >
                                <SoilProfileMapClose />
                            </button>
                        </div>
                        <div className='map-menu-second-div'>
                            <Input
                                prefix={<SearchSvgComponent />}
                                className='map-search'
                                onChange={handleInputValueChange}
                                value={inputLatLngValue}
                            />
                            <button
                                className={`${searchButtonEnable ?
                                    'map-search-button-enable' : 'map-search-button-unable'} map-search-button`}
                                onClick={handleSearchButtonClick}
                            >
                                Search
                            </button>
                        </div>
                        <div className='map-menu-third-div'>
                            <span>
                                Search location by coordinates or location name
                            </span>
                        </div>
                        <div className='map-menu-fourth-div'>
                            <span>Location:</span>
                            <List
                                className='map-result-list'
                                dataSource={geoDataSource}
                                renderItem={(item) => {
                                    return (
                                        <List.Item key={item.geonameId}>
                                            <div className='loation-in-div' onClick={() =>
                                                handleAddressClick(item)}
                                            >
                                                <div className='left-div'>
                                                    <div className={item.geonameId === geonameId ? 'pre-color' : ''}/>
                                                </div>
                                                <div className='right-div'>
                                                    <div>
                                                        <span className='country-name-span'>{item.adminName1}</span>
                                                    </div>
                                                    <div>
                                                        <span className='country-name-sub-span'>{item.countryName}</span>
                                                    </div>
                                                    <div>
                                                        <span className='country-name-coordinate-span'>{item.lng},{item.lat}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </List.Item>
                                    );
                                }}
                            />
                        </div>
                        <div className='map-menu-fifth-div'>
                            <button className='close-button' onClick={handleCloseMap}>
                                Close Map
                            </button>
                        </div>
                    </div>
                </IF>
                <div className='map-component-container'>
                    <GoogleMapReact
                        style={{ height: 'calc(100vh - 56px)'}}
                        onChange={({ zoom, bounds }) => {
                            setZoom(zoom);
                            setBounds([
                                bounds.nw.lng,
                                bounds.se.lat,
                                bounds.se.lng,
                                bounds.nw.lat
                            ]);
                        }}
                        bootstrapURLKeys={{
                            key: 'AIzaSyDlsxkoR8-fiIgncnDunmEtWEwDmr896H0',
                            libraries: ['drawing']
                        }}
                        options={(maps) => {
                            return {
                                mapTypeId: maps.MapTypeId.SATELLITE,
                                fullscreenControl: false
                            };
                        }}
                        yesIWantToUseGoogleMapApiInternals={true}
                        defaultCenter={defaultCenter}
                        center={selectedCoordinate}
                        defaultZoom={defaultZoom || 15}
                        onGoogleApiLoaded={handleGoogleApiLoaded}
                        onClick={mapClick}
                    >
                        {polyLinePointsComponent}
                        {clickPoint}
                        {type === 'QUERY' && clusters.length > 0 && clusters.map(cluster => {
                            const [longitude, latitude] = cluster.geometry.coordinates;
                            const {
                                cluster: isCluster,
                                point_count: pointCount
                            } = cluster.properties;
                            if (isCluster) {
                                return (
                                    <SoilSearchProfileCount
                                        key={`cluster-${cluster.id}`}
                                        lat={latitude}
                                        lng={longitude}
                                        className='marker-annotation-count'
                                        onClick={() => {
                                            console.log('click the profile count marker');
                                        }}
                                    >
                                        <span
                                            className={pointCount > 9 ? 'point-count-more-than-99-span' : 'point-count-span'}
                                        >
                                            {pointCount > 99 ? '99+' : pointCount}
                                        </span>
                                    </SoilSearchProfileCount>
                                );
                            }
                            const keyString = `crime-${cluster.properties.crimeId}`;
                            return (
                                <SoilProfileMarker
                                    key={keyString}
                                    keyString={keyString}
                                    lat={latitude}
                                    lng={longitude}
                                    profileCode={cluster.profileCode}
                                    profileId={cluster.profileId}
                                    propertySet={propertySet}
                                    className={'soil-map-maker'}
                                />
                            );
                        })}
                        { defaultCoordinate && !!defaultCoordinate.lat && (
                            <NormalSoilProfileMarker
                                lat={defaultCoordinate.lat}
                                lng={defaultCoordinate.lng}
                                className={'soil-map-maker'}
                            />
                        )}
                    </GoogleMapReact>
                    <IF show={type === 'FIND'}>
                        <button className='find-toggle-map-center' onClick={() => handleShowCurrentLocation()}>
                            <SoilProfileMapCurrentLocationIcon />
                        </button>
                    </IF>
                    <IF show={type === 'QUERY'}>
                        <button className='query-toggle-map-center' onClick={() => handleShowCurrentLocation()}>
                            <SoilProfileMapCurrentLocationIcon />
                        </button>
                    </IF>
                    <IF show={type !== 'SHOW'}>
                        <div className={`zoom-action-div ${type === 'FIND' ? 'right-hand' : 'left-hand'}`}>
                            <button className='zoom-in-button' onClick={() => {
                                let zoom = mapRef.current.getZoom();
                                mapRef.current.setZoom(zoom-=1);
                            }}>
                                <SoilProfileZoomIn />
                            </button>
                            <button className='zoom-out-button' onClick={() => {
                                let zoom = mapRef.current.getZoom();
                                mapRef.current.setZoom(zoom+=1);
                            }}>
                                <SoilProfileZoomOut />
                            </button>
                        </div>
                    </IF>
                    <IF show={showPolyMenu}>
                        <div className='google-map-operation-menu'>
                            <div>
                                <button onClick={() => {
                                    polygonRef.current?.setMap(null);

                                    // dispatch(updateFourthTabValues({
                                    //     drawCircleMode: false,
                                    //     drawReactModel: true
                                    // }));
                                    dispatch(updateFourthDrawFlag({
                                        drawCircleMode: false,
                                        drawReactModel: true
                                    }));
                                }}>
                                    <SoilNewReactIcon selected={drawReactModel} />
                                </button>
                            </div>
                            <div>
                                <button onClick={() => {
                                    // setDrawReactModel(false);
                                    // setDrawCircleMode(!drawCircleMode);
                                    // dispatch(updateFourthTabValues({
                                    //     drawCircleMode: true,
                                    //     drawReactModel: false
                                    // }));
                                    dispatch(updateFourthDrawFlag({
                                        drawCircleMode: true,
                                        drawReactModel: false
                                    }));
                                }}>
                                    <IF show={drawCircleMode}>
                                        <SoilSearchiCircleSelectedIcon />
                                    </IF>
                                    <IF show={!drawCircleMode}>
                                        <SoilSearchCircleIcon />
                                    </IF>
                                </button>
                            </div>
                            <div>
                                <button onClick={() => clearButtonClick()}>
                                    <SoilSearchClearPolyIcon />
                                </button>
                            </div>
                        </div>
                    </IF>
                </div>
            </div>
        </Spin>
    );
};

export type {
    ICoordinate
};

export default GoogleMapReactComponent;
